import { theme } from 'components';
import styled from 'styled-components';

export const ActionText = styled.span<{
  disabled?: boolean;
  padLeft?: boolean;
}>`
  color: ${theme.blueBase};
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  ${props => props.disabled && 'opacity: 0.5; cursor: not-allowed;'}
  ${props => props.padLeft && 'padding-left: 16px;'}
`;
